module.exports = __webpack_public_path__ + "img/drt15.ddb42ae5.png";